import {
  COMPOSITE_NAME_PREFIX,
  CompositeExpr,
  CompositeNode,
  CompositeNodeRef,
  CompositeRef,
  CompositeSourceRef,
} from '../../../types/composite'

export const compositeIndicatorName = (libraryId: string): string =>
  `${COMPOSITE_NAME_PREFIX}${libraryId}`

export const isCompositeName = (name?: string | null): boolean =>
  !!name && name.startsWith(COMPOSITE_NAME_PREFIX)

export const compositeIdFromName = (name: string): string =>
  name.slice(COMPOSITE_NAME_PREFIX.length)

export const isNodeRef = (ref: CompositeRef): ref is CompositeNodeRef => 'node' in ref

export const isSourceRef = (ref: CompositeRef): ref is CompositeSourceRef => 'source' in ref

export const collectExprRefs = (expr: CompositeExpr): CompositeRef[] => {
  if (expr.t === 'const') return []
  if (expr.t === 'ref') return [expr.ref]
  return expr.args.flatMap(collectExprRefs)
}

export const nodeRefs = (node: CompositeNode): CompositeRef[] => {
  if (node.kind === 'indicator') return node.input ? [node.input] : []
  return collectExprRefs(node.expr)
}

export const exprDepth = (expr: CompositeExpr): number =>
  expr.t === 'op' ? 1 + Math.max(...expr.args.map(exprDepth)) : 1
